<template>
  <div>
    <div v-if='pdfDoc'>
      <button @click="onPrevPage">上一页</button>
      <button @click="onNextPage">下一页</button>
      <span>Page: <span v-text="pageNum"></span> / <span v-text="pages"></span></span>
    </div>
    <div class="pdfContent"
         id="div_read_area_scrool">
      <canvas v-for="page in pages"
              :id="'canvas'+page"
              :key="page" />
    </div>
  </div>
</template>
<script>
import PDFJS from 'pdfjs-dist'
import $ from 'jquery'
import { MessageBox, Message, Loading } from 'element-ui'
import { request } from '../API/ApiUrl'
export default {
  name: 'pdf',
  data () {
    return {
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      scale: 0.8,
      loading: '',
      isScroll: false,
      // PDFJS: null,

    }
  },
  props: {
    pdfUrl: String,
    pages: Number,
    id: Number,
  },
  watch: {
    pdfUrl () {
      if (this.pdfUrl && this.id) {
        //this.startLoading();
        this.pageNum = 1
        this.loadFile(this.pdfUrl);
      }
    }
  },
  methods: {
    startLoading: function () { //使用Element loading-start 方法
      this.loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    endLoading: function () {
      if (this.loading) {
        this.loading.close();
      }
    },
    base64ToUint8Array: function (base64) {
      var raw = atob(imageData.replace(/^data:pdf\/(png|jpeg|jpg);base64,/, ''));//atob(base64);
      var uint8Array = new Uint8Array(raw.length);
      for (var i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i);
      }
      return uint8Array;
    },
    /*加载PDF文件*/
    loadFile: function (url) {
      let self = this;
      //url += '&startPage='+_this.pageNum+'&endPage='+_this.pageNum
      //console.log("+++")
      request('/api/showPdfBreak', {
        path: self.pdfUrl,
        id: self.id,
        startPage: self.pageNum,
        endPage: self.pageNum,

      }, { responseType: 'text' }).then(res => {
        //var pdfData = self.base64ToUint8Array(res);

        // var base64Str = window.atob(res.substring(res.indexOf(',') + 1));

        // var out = new ArrayBuffer(base64Str.length);
        // var u16a = new Uint8Array(out);
        // // var strs = base64Str.split("");
        // for (var i = 0; i < base64Str.length; i++) {
        //   u16a[i] = base64Str[i].charCodeAt();
        // }



        // var rawLength = res.length;  
        // //转换成pdf.js能直接解析的Uint8Array类型,见pdf.js-4068  
        // var array = new Uint8Array(new ArrayBuffer(rawLength));    
        // for(var i = 0; i < rawLength; i++) {  
        //   array[i] = PDFData.charCodeAt(i) & 0xff;  
        // } 
        //console.log(u16a, '123')
        PDFJS.getDocument({ url: url, rangeChunkSize: 65536 * 16 }).then(function (pdfDoc_) {
          //PDFJS.getDocument(url).then(function(pdfDoc_) {

          self.pdfDoc = pdfDoc_;
          // document.getElementById('div_read_area_scrool').textContent = self.pageNum
          //console.log("======pages====" + self.pages)
          //self.pages = 50;
          // Initial/first page rendering
          // var pDiv = document.getElementById("div_read_area_scrool");
          // var strHtml ="";
          // for(var i=1;i<=self.pages;i++)
          // {
          //  //var id = 'candvas'+i;
          //  strHtml+="<canvas id='canvas"+i+"'></canvas>";
          // }
          //  pDiv.innerHTML = strHtml;
          //             self.renderPage(self.pageNum);
          self.$nextTick(() => {
            self.renderPage(self.pageNum);
          });
        });

      }).catch(res => {
        //console.log(res)
        self.endLoading()
      })


    },
    /*渲染PDF文件*/
    renderPage: function (num) {

      let _this = this;
      _this.pageRendering = true;
      // Using promise to fetch the page
      this.pdfDoc.getPage(1).then(function (page) {
        var viewport = page.getViewport(_this.scale);
        let canvas = document.getElementById('canvas' + num);
        let ctx = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        var renderTask = page.render(renderContext);


        // Wait for rendering to finish
        renderTask.promise.then(function () {
          _this.pageRendering = false;
          if (_this.pageNumPending !== null) {
            // New page rendering is pending
            _this.renderPage(_this.pageNumPending);
            _this.pageNumPending = null;
          }
          if (_this.pageNum < _this.pages) {
            _this.pageNum++
          }
          _this.endLoading();
          _this.isScroll = false;
        });
      }).catch(err => {
        //console.log(err)
        _this.endLoading();
        _this.isScroll = false;
      })
    },
    watchTheReadScroll: function () {
      let _theVue = this
      // 获取节点  
      let _scrollContent = document.getElementById('div_read_area_scrool')
      // 绑定事件  
      _scrollContent.addEventListener('scroll', function () {
        var viewH, scrollTop
        viewH = 600
        scrollTop = $(this).scrollTop()
        // 后期改成传递给父级  
        if (scrollTop / viewH >= 0.3) { // 到达底部时,加载新内容 
          if (!_theVue.isScroll) {
            //_theVue.onNextPage();
            _theVue.loadFile(_theVue.pdfUrl);
            _theVue.isScroll = true;
          }

        }
      })
    },

    queueRenderPage: function (num) {
      if (this.pageRendering) {
        this.pageNumPending = num
      } else {
        //this.startLoading();
        this.renderPage(num)
      }
    },
    onPrevPage: function () {
      if (this.pageNum <= 1) {
        return
      }
      this.pageNum--
      this.queueRenderPage(this.pageNum)
    },
    onNextPage () {
      //console.log("====================")
      if (this.pageNum > this.pages) {
        return
      }
      this.queueRenderPage(this.pageNum)
    }

  },
  created: function () {
    if (this.pdfUrl) {
      this.loadFile(this.pdfUrl);
    }
  },
  mounted: function () {

    this.watchTheReadScroll()
  }
}
</script>
<style>
.pdfContent {
  width: 900px;
  height: 600px;
  overflow: scroll;
}
</style>